module.exports = __webpack_public_path__ + "fonts/NeuePlak-CompBold.4c79987b.woff";